//#region Angular Imports

import { StateService } from '@uirouter/angularjs'

//#endregion

//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { Api, LocalDictionaryFactory } from './../api/api.module'
import { ColumnModel } from '../api/api.models'

import { BaseGridController, ScopeBaseGrid } from '../common/common.base.grid.controller'
import { ButtonsOptions } from '../common/grid/grid.controller'
import { DetailsOptions } from '../common/details-popup/details-popup.directive'
import { GridTypes, GridController } from '../common/grid/grid.controller'
import { LoggerService } from './../common/common.module'

import { CommonHelper } from '../../helpers/common-helper'
import { EventsNames } from '../../helpers/events-names'


import { GridContextMenuService } from '../../services/grid'
import { UserSessionService } from '../../services/user-session'
import { SystemService } from '../../services/system'

import { Enums } from '../../models/common/enums'
import { Activity } from '../../models/common/activity'
import { OpAlarmEvent } from '../../models/dw'
import { AlarmHelper } from './alarms.helper'

export interface AlarmsScope extends ScopeBaseGrid {
}

export class AlarmController extends BaseGridController {

    // Consts

    private get GRID_NAME() { return 'AlarmGrid' }

    // Consts End


    // Members

    private grid: GridController<OpAlarmEvent>

    // Members End


    constructor(
        protected $scope: AlarmsScope,
        $state: StateService,
        $timeout: ng.ITimeoutService,
        api: Api,
        private logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        private gridContextMenuService: GridContextMenuService,
        protected userSession: UserSessionService,
        protected systemService: SystemService,
        referenctType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super($scope, $timeout, $state, userSession, systemService, api, localDictionary, null, referenctType)

        this.setEvents()
        this.setMainGridOptions()
    }

    // Events 

    onInitialized(e: any, grid: GridController<OpAlarmEvent>) {
        this.grid = grid
        this.dataGrid = e.component

        this.setGridId(e.tableId)
    }

    onShowDetails(e: any) {
        const detailsOptions: DetailsOptions = {
            idReferenceType: this.referenceType,
            moduleName: this.moduleName,
            pageItemsIds: this.grid.pageItemsIds,
            referenceObjectId: this.grid.selectedItemId
        }

        this.showDetails(e, detailsOptions)
    }

    onConfirmAlarm() {
        if (_.isArray(this.grid.selectedItemsIds)) {
            AlarmHelper
                .confirmAlarm(this.grid.selectedItemsIds, this.userSession)
                .then((alarmEvents: OpAlarmEvent[]) => {
                    this.grid.dxGrid.refresh()
                    this.$scope.$root.$broadcast(EventsNames.ALARM_APPROVED, this.grid.selectedItemsIds.length)
                })
        }
    }

    onConfirmedAlarm() {
        this.grid.dxGrid.refresh()
    }

    // Events End

    // Setup

    private getContextMenuItems(isTouchScreen: boolean = false): any[] {
        const items = this.gridContextMenuService.getContextMenuItemsByReferenceType(Enums.ReferenceType.IdAlarmEvent, {
            idReferenceTypes: this.grid.selectedItemsIds,
            onConfirmAlarm: () => this.onConfirmAlarm(),
        })

        return this.mergeWithDefaultItems(isTouchScreen, items);
    }

    private getGridButtonsOptions(): ButtonsOptions {
        return {
            enabled: true,
            saveColumnSettingsPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP) ? "['" + Activity[Activity.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP] + "']" : null,
            showDetailsPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.ALARM_LIST) ? "['" + Activity[Activity.ALARM_LIST] + "']" : null,

            onShowClick: (e: any) => this.onShowDetails(e),
        }
    }

    private setEvents(): void {
        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__CONFIRMED, this.moduleName),
            (event: ng.IAngularEvent, ...args: any[]) => this.onConfirmedAlarm()
        )

        this.$scope.showDetails = (e: any) => this.onShowDetails(e)
    }

    private setMainGridOptions(): void {
        $.when(
            this.userSession
                .getDataProvider().System
                .getRequestColumnInfo(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__GRID_PARAMS, this.moduleName),
            this.userSession
                .getDataProvider().System
                .getRequestColumnInfo(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__DEFAULT_GRID_PARAMS, this.moduleName)
        ).then((columns: ColumnModel[], defaultColumns: ColumnModel[]) => {
            this.$scope.mainGridOptions = {
                referenceId: this.referenceType,
                idReferenceType: this.referenceType,
                type: GridTypes.MAIN,
                name: this.GRID_NAME,
                addCustomFilters: true,
                buttonsOptions: this.getGridButtonsOptions(),
                columnsDictionary: columns,
                dataSourceAdditionalFields: null,
                defaultColumnsDictionary: defaultColumns,
                localStorageVarForSavedEntity: CommonHelper.localStorageVarForSavedEntity.alarmGroupSaved,
                preExecuteClearFilter: this.preExecuteGridClearFilter,

                allowColumnReordering: !this.userSession
                    .getLoggedOperator()
                    .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.AlarmEventModuleMainGrid),

                getDataSourceMethod: this.userSession
                    .getDataProvider().AlarmEvent.getAlarmEventFilter,

                onInitialized: (e: any, grid: GridController<OpAlarmEvent>) => this.onInitialized(e, grid),
                onDataReady: (data: any) => this.onDataReady(data),
                onRowDoubleClick: (e: any) => this.onShowDetails(e),
                contextMenuItems: () => this.getContextMenuItems(),
            }
        })
    }
}